module.exports = __webpack_public_path__ + "img/logo-ixasia-index-white.e42c1782.png";